export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center justify-center"
      style={{
        backgroundImage:
          'url(https://readdy.ai/api/search-image?query=clean%20professional%20Japanese%20auto%20repair%20garage%20interior%20with%20mechanic%20in%20blue%20uniform%20inspecting%20a%20silver%20car%20on%20hydraulic%20lift%2C%20white%20walls%2C%20organized%20tools%20neatly%20arranged%2C%20bright%20fluorescent%20lighting%2C%20gray%20painted%20concrete%20floor%2C%20tidy%20and%20professional%20workshop%20atmosphere%2C%20no%20clutter%2C%20high%20quality%20realistic%20photography%2C%20warm%20natural%20light&width=1920&height=1080&seq=hero001&orientation=landscape)',
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        <div
          className="inline-block bg-green-600/90 text-white text-sm font-semibold px-5 py-1.5 rounded-full mb-6 tracking-wide"
          style={{ animation: 'fadeInDown 0.7s ease both' }}
        >
          地域密着の自動車修理工場
        </div>

        <h1
          className="text-3xl md:text-5xl font-bold text-white leading-tight mb-6"
          style={{ animation: 'fadeInUp 0.8s ease 0.1s both' }}
        >
          愛車のキズ・へこみ、車検、<br className="hidden md:block" />
          タイヤ交換はお任せください。
        </h1>

        <p
          className="text-lg md:text-xl text-white/85 mb-4 leading-relaxed"
          style={{ animation: 'fadeInUp 0.8s ease 0.2s both' }}
        >
          地域の皆様の安心・安全なカーライフを、誠実な整備でサポートします。
        </p>

        <p
          className="text-base text-white/75 mb-10 flex flex-wrap items-center justify-center gap-4"
          style={{ animation: 'fadeInUp 0.8s ease 0.3s both' }}
        >
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-green-400" />
            お見積り無料
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-green-400" />
            代車ご用意可能（要予約）
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-green-400" />
            国産車・輸入車 対応
          </span>
        </p>

        {/* CTA Buttons */}
        <div
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
          style={{ animation: 'fadeInUp 0.8s ease 0.4s both' }}
        >
          <a
            href="tel:0000000000"
            className="flex items-center gap-3 bg-white text-gray-800 font-bold text-lg px-8 py-4 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap shadow-lg"
          >
            <div className="w-6 h-6 flex items-center justify-center text-green-600">
              <i className="ri-phone-fill text-xl" />
            </div>
            000-000-0000
          </a>
          <a
            href="https://lin.ee/xxxxxxx"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center gap-3 text-white font-bold text-lg px-8 py-4 rounded-lg hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap shadow-lg"
            style={{ backgroundColor: '#06C755' }}
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-line-fill text-xl" />
            </div>
            LINEで問い合わせる
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-white/60 text-xs"
        style={{ animation: 'bounce 2s infinite' }}>
        <span>スクロール</span>
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-down-line" />
        </div>
      </div>

      <style>{`
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes bounce {
          0%, 100% { transform: translateX(-50%) translateY(0); }
          50% { transform: translateX(-50%) translateY(6px); }
        }
      `}</style>
    </section>
  );
}
